module.exports = __webpack_public_path__ + "img/enterprise-logo.a49cf6d4.jpg";